import { z } from "zod";
import { OperatorEnvironment } from "../common.ts";

/**
 * `GET /explorer/v1/installation` (public, served by `iam`; ADR 0011, design D6 of
 * bind-operator-environment-to-installation, spec explorer-access "[FR] Installation environment
 * badge"): the operator environment this installation serves and the public base URL of its Token
 * and Verify APIs (used as given; it may contain a path). The values come from the installation's configuration, never from
 * the request or the hostname. It carries no secret, no version and no hostname-derived data, and
 * is answered with `Cache-Control: public, max-age=300`.
 */
export const InstallationV1 = z
  .object({
    environment: OperatorEnvironment,
    api_base_url: z.url(),
  })
  .strict()
  .meta({ id: "InstallationV1" });
export type InstallationV1 = z.infer<typeof InstallationV1>;

/** `max-age` (seconds) of the public `Cache-Control` of `GET /explorer/v1/installation`. */
export const INSTALLATION_CACHE_MAX_AGE_SECONDS = 300;

/**
 * `GET /explorer/v1/installation/administration` (served by `iam`; change
 * adopt-installation-per-customer, design D14 items 1 and 4, ADR 0022): whether this installation
 * has the Platform area (`STRUST_PLATFORM_ADMINISTRATION`). `enabled` in the platform installation,
 * the internal customer `test` and local; `disabled` in a customer installation, where the console
 * hides the Platform menu and shows the customer's "Integration" screen. Needs a live session (it
 * is read after the login), answered `no-store`. A route of its own, so the strict `InstallationV1`
 * that a console of an earlier release parses stays unchanged.
 */
export const InstallationAdministrationV1 = z
  .object({ platform_administration: z.enum(["enabled", "disabled"]) })
  .strict()
  .meta({ id: "InstallationAdministrationV1" });
export type InstallationAdministrationV1 = z.infer<typeof InstallationAdministrationV1>;
